import API from "../../../utils/helpers/API.helpers";

const DosenSidangService = {
  async getMKSpesialBimbingan(tipe, term) {
    if (tipe && term) {
      return await API.get({
        endpoint: `/dosen/dashboard/get-ta-pembimbing?tipe=${tipe}&term=${term}`,
      });
    }
    console.error(`Undefined, tipe: ${tipe} and term: ${term}`);
  },
  async getMKSpesialYangDiuji(tipe, term) {
    if (tipe && term) {
      return await API.get({
        endpoint: `/dosen/dashboard/get-ta-penguji?tipe=${tipe}&term=${term}`,
      });
    }
    console.error(`Undefined, tipe: ${tipe} and term: ${term}`);
  },

  async getStatMKSpesialBimbingan(term) {
    if (term) {
      return await API.get({
        endpoint: `/dosen/dashboard/get-ta-pembimbing/stats?term=${term}`,
      });
    }
    console.error(`Undefined, term: ${term}`);
  },
  async getStatMKSpesialYangDiuji(term) {
    if (term) {
      return await API.get({
        endpoint: `/dosen/dashboard/get-ta-penguji/stats?term=${term}`,
      });
    }
    console.error(`Undefined, term: ${term}`);
  },
};

export { DosenSidangService };
